import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createRole,
  fetchPermissions,
} from "../../redux/features/roles/rolesSlice";
import { toast } from "react-toastify";

function AddNewRole({ refetchRoles }) {
  const dispatch = useDispatch();
  const { permissions, createRoleLoading } = useSelector(
    (state) => state.roles,
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    permissions: [],
  });

  const [errors, setErrors] = useState({});

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchPermissions());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    const id = Number(value);

    if (name === "permissions") {
      setFormData((prev) => ({
        ...prev,
        permissions: checked
          ? [...prev.permissions, id]
          : prev.permissions.filter((pid) => pid !== id),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (formData.permissions.length === 0) {
      newErrors.permissions =
        "Permissions are required, Select at least one permission.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      return;
    }

    try {
      const payload = {
        name: formData.name,
        permissions: formData.permissions,
      };

      await dispatch(createRole(payload)).unwrap();
      toast.success("Role Created Successfully");
      setFormData({ name: "", permissions: [] });
      handleClose();
      refetchRoles();
    } catch (error) {
      if (error?.errors) {
        const formattedErrors = {};

        Object.keys(error.errors).forEach((key) => {
          formattedErrors[key] = error.errors[key][0];
        });

        setErrors(formattedErrors);
      } else if (error?.message) {
        toast.error(error.message);
      } else {
        toast.error("Creation Failed");
      }
    }
  };

  return (
    <div>
      <button
        onClick={handleOpen}
        className="bg-lightPurple hover:bg-purpleColor p-2 rounded-lg text-white"
      >
        <FontAwesomeIcon icon={faPlus} className="mr-1" />
        Add New Role
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%]  p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5">
              Add New Role
            </h2>

            <form className="space-y-10" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 gap-5">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Role Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Role Name"
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-purpleColor"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>

                <div className="flex flex-col md:col-span-2">
                  <label className=" text-gray-700 font-medium mb-1">
                    Permissions <span className="text-red-500">*</span>
                  </label>

                  <div
                    className="border border-gray-300 rounded-md p-3 h-[19vw] overflow-y-auto"
                    style={{ scrollbarWidth: "none" }}
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                      {permissions?.map((permission) => (
                        <label
                          key={permission.id}
                          className="flex items-center gap-2 p-2 rounded-md
                           hover:bg-gray-50 cursor-pointer transition"
                        >
                          <input
                            type="checkbox"
                            name="permissions"
                            value={permission.id}
                            checked={formData.permissions.includes(
                              permission.id,
                            )}
                            onChange={handleChange}
                            className="h-4 w-4 text-primary border-gray-300 rounded
                             focus:ring-primary cursor-pointer"
                          />
                          <span className="text-sm capitalize text-gray-700">
                            {permission.name}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {errors.permissions && (
                    <p className="text-red-500 text-sm mt-1 text-left">
                      {errors.permissions}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={createRoleLoading}
                  className={`px-4 py-2 rounded-md text-white ${
                    createRoleLoading
                      ? "bg-lightPurple/60 cursor-not-allowed"
                      : "bg-lightPurple hover:bg-purpleColor"
                  }`}
                >
                  {createRoleLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddNewRole;
